import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h5>{`第二軌：技術實作`}</h5>
    <ul>
      <li parentName="ul">{`在面對複雜的需求時，該如何讓我們的程式親切地說出使用者故事及商業邏輯？`}</li>
      <li parentName="ul">{`是否團隊總是在快速迭代滿足業務高速成長的同時，也不斷地累積了高額的技術債務？`}</li>
      <li parentName="ul">{`如果在不適當的時機，選擇了不適當的設計與建模方案，會造成嚴重的維護負擔，進一步將團隊推向維護的地獄深淵。`}</li>
      <li parentName="ul">{`因此，如何在設計不足與過度設計中適當地取得平衡，就需要瞭解在不同的場景時，該如何選擇與取捨。`}</li>
      <li parentName="ul">{`包含：`}<ol parentName="li">
          <li parentName="ol">{`DDD 戰術的各種運用場景`}</li>
          <li parentName="ol">{`軟體架構設計相關議題`}</li>
          <li parentName="ol">{`其他相關設計模式`}</li>
        </ol></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      